import React from 'react';
import KnaekPrimaryButton from "../../AppComponents/KnaekPrimaryButton";
import {stringsTranslate} from "../../../locales/CustomTranslater";
import {appWords} from "../../../config/Constants";
import {useHandleLinkClick} from "../../../hooks/useHandleLinkClick";


export default function Section7ForCompanies() {
    const handleLinkClick = useHandleLinkClick();


    const initStrings = {
        buttonText: stringsTranslate(appWords.contact_us),

        headingSection2: stringsTranslate(appWords.what_does_knaek_cost_for_companies),
        subheadingSection2_1: stringsTranslate(appWords.knaek_cost_description),
        subheadingSection2_2: stringsTranslate(appWords.in_summary),
        subheadingSection2_3: stringsTranslate(appWords.no_coupon_commission),
        subheadingSection2_4: stringsTranslate(appWords.no_cost_per_click),
        subheadingSection2_6: stringsTranslate(appWords.students_cover_90_percent),
        subheadingSection2_7: stringsTranslate(appWords.affordable_and_effective),
        subheadingSection2_8: stringsTranslate(appWords.visibility_without_margin_loss),

        playImg2: "/assets/images/ForCompanies/Visual1 2.webp",
    }

    return (
        <section className="section " id='partnership'>
            <div className="container-fluid">


                {/*Section 7*/}
                <div className="row mt-5 justify-content-center align-items-center px-2 px-md-5 px-lg-5 py-md-5 py-lg-5 py-0">
                    <div className="col-lg-12 col-md-12 col-sm-12 text-center">
                        <KnaekPrimaryButton
                            title={initStrings.buttonText}
                            onClick={() => handleLinkClick("/contact")}

                        />
                    </div>

                    <div className="col-lg-5 col-md-12 text-center d-none d-lg-inline">
                        <img src={initStrings.playImg2} className={"w-100"} alt={""}/>
                    </div>


                    <div className="col-lg-7 col-md-12 flex-wrap d-flex align-items-center mt-5 list">
                        <h1 className="pr-5 heading-section7-for-companies text-knaek-title">{initStrings.headingSection2}</h1>

                        <text className="mt-2 p-1 line-text text-knaek-title subheading-section7-for-companies">{initStrings.subheadingSection2_1}</text>
                        <text className="mt-2 p-1 line-text text-knaek-title subheading-section7-for-companies">{initStrings.subheadingSection2_2}</text>
                        <ul className={"w-100"}>
                            <li className={"ml-2 line-text text-knaek-title subheading-section7-for-companies pr-0 pr-lg-5 pr-md-5"}>
                                {initStrings.subheadingSection2_3}
                            </li>
                            <li className={"ml-2 line-text text-knaek-title subheading-section7-for-companies pr-0 pr-lg-5 pr-md-5"}>
                               {initStrings.subheadingSection2_4}
                            </li>
                            <li className={"ml-2 line-text text-knaek-title subheading-section7-for-companies pr-0 pr-lg-5 pr-md-5"}>
                                {initStrings.subheadingSection2_6}
                            </li>
                            <li className={"ml-2 line-text text-knaek-title subheading-section7-for-companies pr-0 pr-lg-5 pr-md-5"}>
                                {initStrings.subheadingSection2_7}
                            </li>
                        </ul>
                        <p className="mt-2 p-1 line-text text-knaek-title subheading-section7-for-companies">{initStrings.subheadingSection2_8}</p>

                    </div>


                </div>
            </div>
        </section>
    );

}
